export enum DurationFormat {
  SHORT,
  LONG,
}
